import { render, staticRenderFns } from "./message-text-md.vue?vue&type=template&id=3b2e1be2&"
import script from "./message-text-md.vue?vue&type=script&lang=ts&"
export * from "./message-text-md.vue?vue&type=script&lang=ts&"
import style0 from "./message-text-md.vue?vue&type=style&index=0&id=3b2e1be2&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports